import { render, staticRenderFns } from "./TranslatePageAdmin.vue?vue&type=template&id=7cecf25a&"
import script from "./TranslatePageAdmin.vue?vue&type=script&lang=js&"
export * from "./TranslatePageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TranslatePageAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports